import { saveAs } from "file-saver";
import { requestAsync } from "redux-query";
import { uuid } from "short-uuid";
import { AllocationKey, DatapointExcelOptionColumnSortEnum, DatapointIdStandardEnum, DatapointsEntityType, UnitOfArea, postDatapointsExcel } from "api/ux/src";
import { language } from "language/default";
const createRequestConfig = (dimensions, measures) => [
    {
        datapointExcelOptions: [
            {
                columnLabel: language.en.funds.benchmark.export.columnFundName,
                columnSort: DatapointExcelOptionColumnSortEnum.Asc,
                datapointName: "FundName"
            },
            {
                columnLabel: language.en.funds.benchmark.export.columnInvestorName,
                datapointName: "InvestorName"
            },
            {
                columnLabel: language.en.funds.benchmark.export.columnBenchmarkName,
                datapointName: "BenchmarkName"
            },
            {
                columnLabel: language.en.funds.benchmark.export.assetClass,
                datapointName: "AssetClass"
            },
            {
                columnLabel: language.en.funds.benchmark.export.vintageYear,
                datapointName: "VintageYear"
            },
            {
                columnLabel: language.en.funds.benchmark.export.geography,
                datapointName: "Geography"
            },
            {
                columnLabel: language.en.funds.benchmark.export.strategy,
                datapointName: "Strategy"
            }
        ],
        dimensions,
        id: "1",
        includeTotalExcelValues: false,
        measures,
        sheetName: language.en.funds.benchmark.export.sheetName,
        totalGroupExcelOptions: []
    }
];
export const exportBenchmarkSettings = (dispatch, includeInvestor, allocationKey, unitOfArea, commitmentCalculation, currency, dashboardOptions) => {
    const withOptions = (queryConfig) => {
        queryConfig.force = true;
        queryConfig.options = queryConfig.options || {};
        if (queryConfig.options.headers) {
            queryConfig.options.headers.requestBlob = "true";
        }
        queryConfig.meta = {
            ...{
                errorMessage: language.en.funds.benchmark.exportBenchmarkConfigurationMessageFailed,
                pendingMessage: language.en.funds.benchmark.exportBenchmarkConfigurationMessageStarted,
                successMessage: language.en.funds.benchmark.exportBenchmarkConfigurationMessageCompletedSuccessfully
            }
        };
        return queryConfig;
    };
    const dimensions = [{ datapoint: { standard: DatapointIdStandardEnum.FundFundId }, name: "FundId" }];
    const measures = [
        { datapoint: { standard: DatapointIdStandardEnum.FundFundName }, name: "FundName", periods: 1 },
        { datapoint: { standard: DatapointIdStandardEnum.FundBenchmarkName }, name: "BenchmarkName", periods: 1 },
        { datapoint: { standard: DatapointIdStandardEnum.FundAssetClass }, name: "AssetClass", periods: 1 },
        { datapoint: { standard: DatapointIdStandardEnum.FundVintageYear }, name: "VintageYear", periods: 1 },
        { datapoint: { standard: DatapointIdStandardEnum.FundGeography }, name: "Geography", periods: 1 },
        { datapoint: { standard: DatapointIdStandardEnum.FundStrategy }, name: "Strategy", periods: 1 }
    ];
    if (includeInvestor) {
        dimensions.push({ datapoint: { standard: DatapointIdStandardEnum.FundInvestorId }, name: "InvestorId" });
        measures.push({ datapoint: { standard: DatapointIdStandardEnum.FundInvestorName }, name: "InvestorName", periods: 1 });
    }
    const requestParameters = {
        datapointsExcelRequest: {
            allocationKey: allocationKey ?? AllocationKey.Nav,
            asOfDate: new Date(),
            commitmentCalculation,
            dashboardOptions,
            entityId: "All",
            entityName: language.en.funds.benchmark.export.entityName,
            entitySubName: "",
            entityType: DatapointsEntityType.Portfolio,
            filters: [],
            id: uuid(),
            requests: createRequestConfig(dimensions, measures),
            selectedCurrency: currency ?? "USD",
            unitOfArea: unitOfArea ?? UnitOfArea.SquareMeter
        }
    };
    if (requestParameters.datapointsExcelRequest && requestParameters.datapointsExcelRequest.dashboardOptions) {
        requestParameters.datapointsExcelRequest.dashboardOptions.excelExcludeSummary = true;
    }
    else if (requestParameters.datapointsExcelRequest) {
        requestParameters.datapointsExcelRequest.dashboardOptions = { excelExcludeSummary: true };
    }
    const requestConfig = postDatapointsExcel(requestParameters, {
        queryKey: "ExportBenchmarkSettings",
        transform: (body) => {
            if (body?.size > 0) {
                saveAs(body, "Benchmark Assignments.xlsx");
            }
            return {};
        }
    });
    withOptions(requestConfig);
    dispatch(requestAsync(requestConfig));
};
